<template>
  <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">
    <div class="sidebar-wrapper">
      <Sidebar class="sidebar-container"></Sidebar>
    </div>
    <div class="main-container">
      <Navbar></Navbar>
      <App-main></App-main>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import {Navbar, Sidebar, AppMain} from '@/components/layout';
  import store from '@/store';
  import {getToken} from '@/utils/auth'

  export default {
    name: 'layout',
    components: {
      Navbar,
      Sidebar,
      AppMain
    },
    computed: {
      sidebar() {
        return this.$store.getters.sidebar;
      }
    },
    beforeRouteEnter: (to, from, next) => {
      store.dispatch('GetInfo').then((res) => {
        return store.dispatch('GetMenu')
      }).then(() => {
        return store.dispatch('SetNeedMobile')
      }).then(() => {
        next();
      })
    }
  }
</script>
<style scoped lang="less">
  .app-wrapper {
    min-height: 100%;
    width: 100%;
    padding-left: 160px;
    padding-top: 86px;
    background-color: #ececec;
    &.hideSidebar {
      padding-left: 20px;
      .sidebar-wrapper {
        transform: translate(-140px,0);
        .sidebar-container{
          transform: translate(120px, 0);
        }
        &:hover {
          transform: translate(0,0);
          z-index: 1001;
          .sidebar-container {
            transform: translate(0,0);
          }
        }
      }

      .navbar {
        left: 20px;
      }

    }

    .sidebar-wrapper {
      width: 160px;
      min-height: 768px;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      z-index: 1001;
      overflow-x: hidden;
      transition: all .28s ease-out;

      &::-webkit-scrollbar-track-piece {
        background: #d3dce6;
      }
      &::-webkit-scrollbar {
         width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background: #99a9bf;
        border-radius: 20px;
      }
    }

    .sidebar-container {
      transition: all .28s ease-out;
    }
    .main-container {
      width: 100%;
      min-height: 100%;
      transition: all .28s ease-out;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue